var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.757 13.243a.75.75 0 0 0 1.061 0l3.094-3.094a.125.125 0 0 1 .176 0l3.094 3.094a.75.75 0 0 0 1.06-1.061L10.15 9.088a.125.125 0 0 1 0-.176l3.094-3.094a.75.75 0 1 0-1.061-1.06L9.088 7.85a.125.125 0 0 1-.176 0L5.818 4.757a.75.75 0 0 0-1.06 1.061L7.85 8.912a.125.125 0 0 1 0 .176l-3.094 3.094a.75.75 0 0 0 0 1.06Z",
  fill: "#000"
})));
export default SvgClose;